import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import './imageside.scss';

const Imageside = () => (
  <motion.div className="app__imageside">
    <motion.img
      src={images.collinsprofileWebp}
      alt="Collins Musoko"
      width={272}
      height={272}
      loading="lazy"
      whileInView={{ scale: [0, 1], opacity: [0, 1] }}
      transition={{ duration: 1.5, ease: 'easeInOut' }}
    />
  </motion.div>
);

export default Imageside;
